import { getAxiosInstance } from '../../../np-rest/rest';

export const fetchDeviceOnlineDataCount = filterData => {
    const rest = getAxiosInstance();

    return async dispatch => {
        try {
            let countRes = await rest.post("/device-online/count", filterData);
            if (countRes.data && countRes.data.succeeded) {
                return countRes.data.result.data
            }
            return 0;
        } catch (error) {
            return 0;
        }
    }
}
export const fetchDeviceOnlineData = filterData => {
    const rest = getAxiosInstance();

    return async dispatch => {
        try {
            let listRes = await rest.post("/device-online/list", filterData);
            if (listRes.data && listRes.data.succeeded) {
                return listRes.data.result.data
            }
            return []

        } catch (error) {
            return []

        }
    }
}

export const removeDevice = queryParams => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post("/device-online/remove", queryParams);
            if (res.data && res.data.succeeded) {
                return;
            }
            return { data: [], count: 0 };
        } catch (error) {
            return { data: [], count: 0 }
        }
    }
}